import * as Cache from '@/lib/cache'

// import { loginByCode, getInfo} from '@/api/user'
// import { getThemeArticleByTime } from '@/api/activity'

import * as MutationTypes from '../mutation-types'
import * as ActionTypes from "../action-types"
import { separateToSpan } from "../../lib/util";

import {
  getArticleDetail,
  getPrimaryWords,
  getRecommendContent,
  getUserArticleContent,
  getArticleLevels,
  getArticleWordBook,
  getArticleQuiz
} from "@/api/article"
import moment from 'moment'
//创建Vuex实例
const state = {
  articleId: 0,
  contentId: 0,
  articleDetail: {},
  words: [],
  quizData: {},
  answer: [],
  levels: [],
  articleContent:{},
  wordBook: [],
  // answerResult: {},
  articleResult: {}
}

const mutations = {
  [MutationTypes.SWTICH_ARTICLE_LEVEL]: (state, level) => {
    state.articleLevel = level
  },
  [MutationTypes.SELECT_ARTICLE_CONTENT]: (state, contentId) => {
    state.contentId = contentId
  },
  [MutationTypes.SET_ARTICLE_DETAIL]: (state, articleDetail) => {
    state.articleDetail = articleDetail
  },
  [MutationTypes.SET_PRIMARY_WORD]: (state, words) => {
    state.words = words
  },
  [MutationTypes.GET_ARTICLE_LEVELS]: (state, levels) => {
    console.log('=====>aaa',levels)
    state.levels = levels
  },
  [MutationTypes.SET_ARTICLE_CONTENT]: (state, articleContent) => {
    articleContent.fullContent = separateToSpan(
      articleContent.fullContent
    );
    state.articleContent = articleContent
    state.quizData = {}
    state.answer = []
    state.startTime = moment().valueOf();

  },
  [MutationTypes.SET_ARTICLE_QUIZ]  : (state,quizData) =>{
    state.quizData = quizData
    state.answer = new Array(quizData.questions.length);
  },
  [MutationTypes.UPDATE_ARTICLE_ANSWER]  : (state,answer) =>{
    state.answer = answer;
  },
  
  [MutationTypes.UPDATE_WORD_BOOK]: (state, wordBook) => {
    state.wordBook = wordBook
  },
  [MutationTypes.SET_ARTICLE_RESULT]: (state, articleResult) => {
    state.articleResult = articleResult
  },
  [MutationTypes.RESET_ARTICLE]: (state) => {
    // state = in
    state = {
      articleId: 0,
      contentId: 0,
      articleDetail: {},
      words: [],
      quizData: {},
      answer: [],
      levels: [],
      articleContent:{},
      wordBook: [],
      articleResult: {}
    }
  },
}
const actions = {
  // 登录相关，通过code获取token和用户信息
  switchLevel({ commit }, level) {
    return new Promise((resolve, reject) => {
      commit(MutationTypes.SWTICH_ARTICLE_LEVEL, level)
      this.dispatch(ActionTypes.GET_ARTICLE_CONTENT)
      resolve(level)
    })
  },
  // selectArticleContent({ commit }, contentId) {
  //   return new Promise((resolve, reject) => {
  //     commit(MutationTypes.SELECT_ARTICLE_CONTENT, contentId)
  //     resolve(contentId)
  //   })
  // },
  getArticleDetail({ commit }, articleId) {
    return new Promise((resolve, reject) => {
      commit(MutationTypes.RESET_ARTICLE)

      getArticleDetail({ articleId }).then(result => {
        commit(MutationTypes.SET_ARTICLE_DETAIL, result.data)
      })
      getPrimaryWords({ articleId }).then((result) => {
        commit(MutationTypes.SET_PRIMARY_WORD, result.data)
      })
      getRecommendContent({ articleId }).then((result) => {
        commit(MutationTypes.SELECT_ARTICLE_CONTENT, result.data)
      });
      getArticleLevels({articleId}).then((result)=>{
        commit(MutationTypes.GET_ARTICLE_LEVELS,result.data)
      })

    })
  },
  getArticleContent({commit}){
    let contentId = state.contentId
    let articleId = state.articleDetail.articleId

    return new Promise((resolve,reject) => {
      //  commit()
      getUserArticleContent({contentId}).then((result)=>{
        commit(MutationTypes.SET_ARTICLE_CONTENT,result.data)
        getArticleWordBook({articleId}).then(res=>{
          commit(MutationTypes.UPDATE_WORD_BOOK,res.data)
        })
      })
    })
  },
  selectArticleContent({commit},contentId){
    commit(MutationTypes.SELECT_ARTICLE_CONTENT, contentId)
    this.dispatch(ActionTypes.GET_ARTICLE_CONTENT)

  },
  updateWordBook({commit}){
    let articleId = state.articleDetail.articleId
    getArticleWordBook({articleId}).then(res=>{
      commit(MutationTypes.UPDATE_WORD_BOOK,res.data)
    })
  },
  getArticleQuestions({commit}){
    let contentId = state.contentId

    getArticleQuiz({contentId}).then(result=>{
      commit(MutationTypes.SET_ARTICLE_QUIZ,result.data)
    })
  },
  updateArticleAnswer({commit},answer){
    commit(MutationTypes.UPDATE_ARTICLE_ANSWER,answer)
  },
  setArticleResult({commit},articleResult){
    commit(MutationTypes.SET_ARTICLE_RESULT,articleResult)
  },
  resetArticle({commit}){
    commit(MutationTypes.RESET_ARTICLE)
  }


  // export const GET_ARTICLE_CONTENT = 'article/getArticleContent'
// export const UPDATE_WORD_BOOK = 'article/updateWordBook'
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



//////////////////
// WEBPACK FOOTER
// ./app/store/modules/article.js
// module id = null
// module chunks = 